import React, { useState, useEffect } from "react";
import { Row, Container } from "reactstrap";

import LessonNavBar from "components/Navbars/LessonNavBar.js";
import LearningHubComponent from "components/LearningHub/LearningHubComponent.js";
import NavigationButton from "../../../../components/NavigationButton/NavigationButton.js";


const JS_M1_L3Component = ({ setAiPageContext, content, onLoadLesson, practiceProblems, onPracticeProblems, setCurrentCode, aiOpenHelpRef, setCurrentOuput }) => {
  const lessonID = "JS103";
  const [pageTitle, setPageTitle] = useState("How to Write and Run JavaScript");

  const [allCheckboxesCompleted, setAllCheckboxesCompleted] = useState(false);


  const setAIContentRefToNull = () => {
    onLoadLesson(null);
    onPracticeProblems(null);
  }

  useEffect(() => {
    setAiPageContext("lesson");
  }, []);


  return (
    <>
      <div className=" lessonBackgroundColor1 lessonMain  h-100vh" >
        <LessonNavBar />
        <main id="main" tabIndex={-1} className="lessonMain flex-grow-1">
          <section>
            <LearningHubComponent setCurrentCode={setCurrentCode} content={content} onLoadLesson={onLoadLesson} practiceProblems={practiceProblems} onPracticeProblems={onPracticeProblems} course={"javascript"} lessonID={lessonID} lessonTitle={pageTitle} setallCheckboxesCompleted={setAllCheckboxesCompleted} aiOpenHelpRef={aiOpenHelpRef} setCurrentOuput={setCurrentOuput} />
          </section>
          <section >
            <Container className="container-lg">
              <Row className=" p-3   align-items-center  justify-content-between">
                <NavigationButton direction="back" page="JS_M1_L2" passFunction={setAIContentRefToNull}></NavigationButton>
                {allCheckboxesCompleted == true && (
                  <NavigationButton direction="next" page="JS_M1_L4" passFunction={setAIContentRefToNull}></NavigationButton>
                )}
              </Row>
            </Container>
          </section>
        </main>
      </div>
    </>
  );
};


export default JS_M1_L3Component;